<template>
  <a
    href="#"
    @click.prevent="doButtonAction"
    target="_self"
    class="c-survey__skip-button"
    :class="{}"
  >
    {{ title }}
  </a>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    buttonAction: {
      type: String,
    },
  },
  methods: {
    changeSliderByName() {
      this.screenList.forEach((screen, index) => {
        if (screen.component === "LiveResultsView") {
          this.currentScreenIndex = index;
          this.navigationDirection = "next";
        }
      });
    },
    doButtonAction() {
      if (this.isDisabled) {
        return;
      } else {
        this.disabledAnimationBackground = true;
        this.changeSliderByName();
      }
    },
  },
  computed: {
    ...mapFields([
      "currentScreenIndex",
      "screenList",
      "navigationDirection",
      "submissionData",
      "isTransitioning",
      "disabledAnimationBackground",
    ]),
    isDisabled() {
      return this.disabled || this.isTransitioning;
    },
  },
};
</script>
